<template>
    <div>
        <span @click="showInfoModal">
             <font-awesome-icon icon="fa-info-circle" />
        </span>
        <b-modal 
            id="modal-enter-availability-info"
            centered
            :title="$t('vehicle.availability.modal.text.1')"
            v-model="isVisible"
        >

            <div class="modal-body text-dark text-left small">
                {{ $t('vehicle.availability.modal.text.2') }}

                <div class="row mt-3">
                    <div class="col-4">
                        <div class="container">
                            <div class="circle">
                                <img src="/images/icon-car-roof.svg" alt="Icon first"/>
                            </div>
                        </div>
                    </div>

                    <div class="col-8 d-flex justify-content-center align-items-center">
                        <div>{{ $t('vehicle.availability.modal.text.3') }}</div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <div class="container">
                            <div class="line"></div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <div class="container">
                            <div class="circle">
                                <img src="/images/icon-car-top.svg" alt="Icon second"/>
                            </div>
                        </div>
                    </div>

                    <div class="col-8 d-flex justify-content-center align-items-center">
                        <div>{{ $t('vehicle.availability.modal.text.4') }}</div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-4">
                        <div class="container">
                            <div class="line"></div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <div class="container">
                            <div class="circle">
                                <img src="/images/icon-car-transporter.svg" alt="Icon third"/>
                            </div>
                        </div>
                    </div>

                    <div class="col-8 d-flex justify-content-center align-items-center">
                        <div>{{ $t('vehicle.availability.modal.text.5') }}</div>
                    </div>
                </div>
            </div>
            <template #modal-footer>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { EventBus } from '../../event-bus';
import { BModal, VBModal  } from "bootstrap-vue";

export default {
    name: 'BuyboxAvailablityInfoModal',
    components: {
        BModal,
    },

    directives: { 
        'b-modal': VBModal 
    },
    props: {
    },
    data() {
        return {
            isVisible: false,
        }
    },
    mounted() {
        EventBus.$on('init-enter-availability-info', this.getData);
    },
    methods: {
        showInfoModal() {
            EventBus.$emit('init-enter-availability-info');
        },
        getData() {
            this.isVisible = true
        },
    },
    computed: {
    },
}
</script>

<style scoped>

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.circle {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    position: relative;
    background-color: #f2f2f2;
    display: flex;
    justify-content: center;
    align-items: center;
}

.line {
    width: 2px;
    height: 30px;
    border: 2px dashed #f2f2f2;
}
</style>